import { ACMEListResponse } from '@b2b/types/core';
import { FormCategoryType, FormResponse } from '@b2b/types/forms';
import { IInjectable } from '@uirouter/angularjs';
import { IPromise } from 'angular';
import { ApiService } from '../services/api/types';

export function FormsDataResolver(
  props = {
    published: '1' as const,
    formCategoryType: 'membership' as FormCategoryType,
    pageSize: '-1',
    page: '1',
    sortField: 'name',
    sortDirection: 'asc' as const,
  }
): IInjectable {
  return [
    'ApiService',
    function FormsData(apiService: ApiService): IPromise<{ data: ACMEListResponse<FormResponse> }> {
      return apiService.form.list(props);
    },
  ];
}
